export const formatPrice = (price: number): string => {
  return `£${price.toFixed(2)}`;
};
